import React from 'react';
import styled from 'styled-components';
import CustomSwapWidget from '../components/swap/CustomSwapWidget';
import BridgeToETHWidget from '../components/swap/BridgeToETHWidget';
import { PageShell } from '../components/shared/PageShell';

const BridgeHeader = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 48px;
  gap: 24px;
  
  @media (max-width: 700px) {
    margin-bottom: 32px;
    gap: 16px;
  }
`;

const HeaderLogo = styled.img`
  height: 80px;
  width: auto;
  object-fit: contain;
  
  @media (max-width: 700px) {
    height: 60px;
  }
`;

const HeaderTitle = styled.h1`
  font-size: 42px;
  font-weight: 300;
  color: #ffffff;
  margin: 0;
  font-family: 'Plus Jakarta Sans', sans-serif;
  letter-spacing: -0.02em;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
  
  @media (max-width: 700px) {
    font-size: 28px;
    gap: 8px;
  }
`;

const RelayIcon = styled.img`
  height: 36px;
  width: auto;
  object-fit: contain;
  
  @media (max-width: 700px) {
    height: 24px;
  }
`;

const HeaderDescription = styled.p`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin: 0;
  max-width: 700px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 300;
  
  @media (max-width: 700px) {
    font-size: 15px;
  }
`;

const HeaderSubtitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: var(--color-neon-purple);
  margin: 8px 0 0 0;
  font-family: 'Plus Jakarta Sans', sans-serif;
  text-shadow: 0 0 15px rgba(188, 19, 254, 0.3);
  
  @media (max-width: 700px) {
    font-size: 18px;
  }
`;

const BridgeContent = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const RelayWidgetWrapper = styled.div`
  background: rgba(20, 20, 30, 0.4);
  border-radius: 20px;
  padding: 24px;
  width: 100%;
  border: 1px solid #333333;
  box-shadow: 0 0 30px #000000;
  backdrop-filter: blur(12px);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #444444, transparent);
  }
`;

const BridgePage: React.FC = () => {
  return (
    <PageShell className="items-center">
      <BridgeHeader>
        <HeaderLogo src="/lockup_white.svg" alt="Mavrk" />
        <HeaderTitle>
          GO ANYWHERE ONCHAIN, INSTANTLY
        </HeaderTitle>
        <HeaderDescription>
          The fastest and cheapest way to bridge & transact across chains.
          <br />
          Relay is a multichain payments network, designed to make swapping and transacting across 100s of chains delightfully simple.
        </HeaderDescription>
        <HeaderSubtitle>
          Bridge to Ink. Trade Mavrk Tokens. Instantly.
        </HeaderSubtitle>
      </BridgeHeader>

      <BridgeContent>
        {/* Bridge to Ink and Cross-chain Swap */}
        <TwoColumnGrid>
          <RelayWidgetWrapper>
            <BridgeToETHWidget />
          </RelayWidgetWrapper>
          <RelayWidgetWrapper>
            <CustomSwapWidget />
          </RelayWidgetWrapper>
        </TwoColumnGrid>
      </BridgeContent>
    </PageShell>
  );
};

export default BridgePage;

